import { CampaignUpdatePage } from "@/features/campaign/pages/CampaignUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/campaign/$id/update")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <CampaignUpdatePage id={id} />;
}
